<div class="position-relative h-100 d-flex flex-column">
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{ 'Create a new ticket' | translate }}</h4>

        <div>
            @if (!selectedForm || (selectedForm && isFormReady)) {
                <button
                    style="margin: -0.5rem 0"
                    class="btn btn-icon"
                    type="button"
                    (click)="openInNewWindow()"
                    [tooltip]="'In new window' | translate"
                    placement="bottom">
                    <sb-inline-svg
                        class="icon"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/icons/external-link-icon.svg'">
                    </sb-inline-svg>
                </button>
            }

            <button
                type="button"
                class="btn btn-icon btn-close btn-transparent"
                aria-label="Close"
                (click)="modalRef.hide()">
                <sb-inline-svg
                    class="icon icon-close"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                </sb-inline-svg>
            </button>
        </div>
    </div>
    <div id="modalContainer" class="modal-body" tabindex="-1" appFocus [appAutoFocus]="true">
        @if (!selectedForm) {
            <app-forms-list
                [areFormsLoading]="areFormsLoading"
                [forms]="forms"
                (formSelected)="selectForm($event)"></app-forms-list>
        } @else {
            @if (!isFormReady) {
                <sb-loader></sb-loader>
            } @else {
                <div class="container mt-3">
                    <app-form-component
                        [form]="form"
                        [formType]="formTypesEnum.webInternal"
                        [isFormFieldsWithRules]="true">
                    </app-form-component>
                </div>
            }
        }
    </div>
    <div class="modal-footer justify-content-between">
        <div class="d-flex align-items-center">
            @if (selectedForm) {
                @if (forms?.length > 1) {
                    <button type="button" class="btn btn-default btn-back" (click)="resetForm()">
                        {{ 'Back' | translate }}
                    </button>
                }
                <label
                    class="checkbox__label checkbox__label--size-small min-width-50 ms-3"
                    for="isCreateAnotherTicket">
                    {{ 'Create another ticket' | translate }}
                    <input
                        type="checkbox"
                        id="isCreateAnotherTicket"
                        name="isCreateAnotherTicket"
                        [(ngModel)]="isCreateAnotherTicket" />
                    <span class="checkbox__checkmark"></span>
                </label>
                <label
                    class="checkbox__label checkbox__label--size-small min-width-50 ms-3 me-3"
                    for="isAssignedToCreator">
                    {{ 'Assign to me' | translate }}
                    <input
                        type="checkbox"
                        id="isAssignedToCreator"
                        name="isAssignedToCreator"
                        [(ngModel)]="isAssignedToCreator" />
                    <span class="checkbox__checkmark"></span>
                </label>
            }
        </div>
        <div class="ms-auto">
            <button type="button" class="btn btn-default me-2" (click)="modalRef.hide()">
                {{ 'Cancel' | translate }}
            </button>

            @if (selectedForm) {
                @if (!commonDataService.customerSettings.isCustomerReplyPortalEnabled) {
                    <button
                        [disabled]="!isFormReady || isSaving || isUploadingFiles"
                        type="button"
                        class="btn btn-primary me-2"
                        data-testid="new-ticket-create"
                        (click)="send(false, false)">
                        {{ 'Create' | translate }}
                    </button>
                    <button
                        [disabled]="!isFormReady || isSaving || isUploadingFiles"
                        type="button"
                        class="btn btn-primary me-2"
                        (click)="send(true, false)">
                        {{ 'Create and close' | translate }}
                    </button>
                } @else {
                    <div
                        dropdown
                        class="btn-group me-2"
                        [isDisabled]="!isFormReady || isSaving || isUploadingFiles"
                        [dropup]="true">
                        <button
                            [disabled]="!isFormReady || isSaving || isUploadingFiles"
                            type="button"
                            class="btn btn-primary"
                            data-testid="new-ticket-create"
                            (click)="send(false, false)">
                            {{ 'Create' | translate }}
                        </button>
                        <button
                            dropdownToggle
                            type="button"
                            class="btn btn-primary dropdown-toggle dropdown-toggle-split"></button>
                        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right reply-link-block">
                            <li>
                                <button type="button" class="btn icon-padding" (click)="send(true, false)">
                                    {{ 'Create and close' | translate }}
                                </button>
                            </li>
                            <li>
                                <button class="btn reply-link" (click)="send(false, true)">
                                    <sb-inline-svg
                                        class="icon ps-0"
                                        aria-label="Link icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'">
                                    </sb-inline-svg>
                                    <span>{{ 'Create with reply-link' | translate }}</span>
                                </button>
                            </li>
                            <li>
                                <button class="btn reply-link" (click)="send(true, true)">
                                    <sb-inline-svg
                                        class="icon ps-0"
                                        aria-label="Link icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'">
                                    </sb-inline-svg>
                                    <span>{{ 'Create with reply-link and close' | translate }}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                }
            }
        </div>
    </div>
</div>

@if (formCommonDataService.isReplyTemplatesModalOpened || assignCategoryAndTagsService.isModalWindowOpen) {
    <bs-modal-backdrop class="modal-backdrop fade in show"></bs-modal-backdrop>
}
